import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34a486e1")

_pushScopeId("data-v-34a486e1")
const _hoisted_1 = { class: "error" }
const _hoisted_2 = { class: "error__title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OButton = _resolveComponent("OButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_OButton, {
      class: "error__retry p-button-secondary",
      icon: "pi pi-refresh",
      "icon-pos": "right",
      label: "Tentar novamente",
      onClick: _ctx.retryCb
    }, null, 8, ["onClick"])
  ]))
})